import React from "react";
import { inputClass } from "helpers/StyleClass";
import { SKIPPABILITY_TYPE } from "./Constants";
import _ from "lodash";

class VideoOptionControl extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      duration:
        props.targeting && props.targeting.minDuration
          ? props.targeting.minDuration
          : 0,
      skippabilityType:
        props.targeting && props.targeting.type
          ? props.targeting.type
          : _.keys(SKIPPABILITY_TYPE)[2],

      skippabilityOptions: _.keys(SKIPPABILITY_TYPE).map((key) => ({
        value: key,
        label: SKIPPABILITY_TYPE[key],
      })),
    };

    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.handleChange();
  }

  handleChange() {
    const { duration, skippabilityType } = this.state;
    this.props.onChange({ minDuration: duration, type: skippabilityType });
  }

  render() {
    const { duration, skippabilityType, skippabilityOptions } = this.state;

    return (
      <div className="border mt-1 px-2 py-1">
        <label className="block font-semibold text-gray-600">
          Minimum Duration (seconds)
        </label>
        <div className="mb-2 w-1/5">
          <input
            className={inputClass}
            type="number"
            min="0"
            value={duration}
            onChange={(e) => {
              const value = parseInt(e.target.value, 10);
              this.setState(
                { duration: isNaN(value) ? 0 : value },
                this.handleChange
              );
            }}
          ></input>
        </div>

        <label className="block font-semibold text-gray-600">
          Video Skippability Type
        </label>
        <div className="flex items-center gap-2">
          {skippabilityOptions.map((option) => (
            <label
              key={option.value}
              htmlFor={`radio_video_option_type_${option.value}`}
              className="cursor-pointer"
            >
              <input
                id={`radio_video_option_type_${option.value}`}
                type="radio"
                name={`radio_video_option_type`}
                value={option.value}
                checked={skippabilityType === option.value}
                onChange={() =>
                  this.setState({ skippabilityType: option.value }, this.handleChange)
                }
              />{" "}
              {option.label}
            </label>
          ))}
        </div>
      </div>
    );
  }
}

export default VideoOptionControl;
